import React, { Fragment, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Container, Row } from "reactstrap";
import axios from 'axios';
import ReactGa from 'react-ga';
import CommonLayout from "../../../../../components/shop/common-layout";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import global_es from "../../../../lang/es/global.json";
import global_en from "../../../../lang/en/global.json";
import { urlApi } from "../../../../../config";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    es: {
      global: global_es
    },
    en: {
      global: global_en
    }
  }
});

const ViewBanner = () => {
  const [loading, setLoading] = useState(true);
  const [banners, setBanner] = useState([]);
  const ClickHandler = () => {
    ReactGa.event({
      category: 'Categoria',
      action: 'Click'
    })
  }
  useEffect(() => {
    let isMountered = true;

    axios.get(`/api/getBanner`).then(res => {
      if (isMountered) {

        if (res.data.status === 200) {
          setBanner(res.data.banner);
          setLoading(false);
        }
      }
    });
    return () => {
      isMountered = false;
    }
  });

  if (loading) {

    return <Container className="col-md-2">
      <Row><h4 className="button-center">Cargando Sub Categorias...</h4>
      </Row>
    </Container>

  } else {
    var showBannerList = '';
    showBannerList =
      banners.map((item, idx) => {
        return (

          <div className="col-12 col-sm-6 col-md-4 button-tp button-mrg" key={idx}>
            <Link to={`/collections/${item.slug}`}>
           
                <div className="collection-banner">
                  <Container className="col-12 col-md-10">
                    <Row>
                      <img src={`https://lordon.com.mx:81/${item.image}`} className="image-fluid img-round" alt={item.image} />

                    </Row>
                  </Container>
                  <br></br>
                  <div className="blog-details" onClick={ClickHandler}>

                    <h3 className="h3-definity">{item.name}</h3>

                  </div>

                </div>

             
            </Link>
          </div>


        )
      });
  }

  return (
    <I18nextProvider i18n={i18next}>
    <CommonLayout parent="collections" title="sub categorias">
      <Fragment >
        {/*collection banner*/}

        <Container className="col-md-12">
          <Row>

            {showBannerList}

          </Row>
        </Container>


        {/*collection banner end*/}
      </Fragment>
    </CommonLayout>
    </I18nextProvider>
  );
};

export default ViewBanner;